export const API_ERROR_CODE_I18N_REASON_ENVIRONMENT_IMAGE: Record<string, string> = {
  activation_archived_forbidden:
    "common.errors.apiCodeReasons.environmentImage.activationArchivedForbidden",
  activation_asset_source_required:
    "common.errors.apiCodeReasons.environmentImage.activationAssetSourceRequired",
  active_os_required: "common.errors.apiCodeReasons.environmentImage.activeOsRequired",
  active_source_required: "common.errors.apiCodeReasons.environmentImage.activeSourceRequired",
  actor_user_required: "common.errors.apiCodeReasons.environmentImage.actorUserRequired",
  already_active: "common.errors.apiCodeReasons.environmentImage.alreadyActive",
  archived_asset_conflict: "common.errors.apiCodeReasons.environmentImage.archivedAssetConflict",
  archived_read_only: "common.errors.apiCodeReasons.environmentImage.archivedReadOnly",
  archived_reimport_forbidden:
    "common.errors.apiCodeReasons.environmentImage.archivedReimportForbidden",
  archived_status_transition_forbidden:
    "common.errors.apiCodeReasons.environmentImage.archivedStatusTransitionForbidden",
  asset_conflict: "common.errors.apiCodeReasons.environmentImage.assetConflict",
  asset_required: "common.errors.apiCodeReasons.environmentImage.assetRequired",
  asset_type_invalid: "common.errors.apiCodeReasons.environmentImage.assetTypeInvalid",
  "batch.ids_required": "common.errors.apiCodeReasons.environmentImage.batchIdsRequired",
  "batch.target_fields_required":
    "common.errors.apiCodeReasons.environmentImage.batchTargetFieldsRequired",
  cloud_init_profile_forbidden_when_disabled:
    "common.errors.apiCodeReasons.environmentImage.cloudInitProfileForbiddenWhenDisabled",
  cloud_init_profile_guest_profile_unsupported:
    "common.errors.apiCodeReasons.environmentImage.cloudInitProfileGuestProfileUnsupported",
  cloud_init_profile_invalid:
    "common.errors.apiCodeReasons.environmentImage.cloudInitProfileInvalid",
  cloud_init_profile_os_family_unsupported:
    "common.errors.apiCodeReasons.environmentImage.cloudInitProfileOsFamilyUnsupported",
  cloud_init_profile_required:
    "common.errors.apiCodeReasons.environmentImage.cloudInitProfileRequired",
  cloud_init_redetect_asset_source_required:
    "common.errors.apiCodeReasons.environmentImage.cloudInitRedetectAssetSourceRequired",
  created_by_mismatch: "common.errors.apiCodeReasons.environmentImage.createdByMismatch",
  docker_command_timed_out: "common.errors.apiCodeReasons.environmentImage.dockerCommandTimedOut",
  docker_load_failed: "common.errors.apiCodeReasons.environmentImage.dockerLoadFailed",
  docker_loaded_image_missing:
    "common.errors.apiCodeReasons.environmentImage.dockerLoadedImageMissing",
  docker_login_failed: "common.errors.apiCodeReasons.environmentImage.dockerLoginFailed",
  docker_push_failed: "common.errors.apiCodeReasons.environmentImage.dockerPushFailed",
  docker_runtime_unavailable:
    "common.errors.apiCodeReasons.environmentImage.dockerRuntimeUnavailable",
  docker_tag_failed: "common.errors.apiCodeReasons.environmentImage.dockerTagFailed",
  duplicate_name_allocation_failed:
    "common.errors.apiCodeReasons.environmentImage.duplicateNameAllocationFailed",
  harbor_api_base_url_invalid:
    "common.errors.apiCodeReasons.environmentImage.harborApiBaseUrlInvalid",
  harbor_api_base_url_missing:
    "common.errors.apiCodeReasons.environmentImage.harborApiBaseUrlMissing",
  harbor_operator_credentials_missing:
    "common.errors.apiCodeReasons.environmentImage.harborOperatorCredentialsMissing",
  harbor_operator_host_misconfigured:
    "common.errors.apiCodeReasons.environmentImage.harborOperatorHostMisconfigured",
  harbor_project_create_failed:
    "common.errors.apiCodeReasons.environmentImage.harborProjectCreateFailed",
  harbor_project_query_failed:
    "common.errors.apiCodeReasons.environmentImage.harborProjectQueryFailed",
  harbor_publish_empty: "common.errors.apiCodeReasons.environmentImage.harborPublishEmpty",
  harbor_request_failed: "common.errors.apiCodeReasons.environmentImage.harborRequestFailed",
  harbor_robot_create_failed:
    "common.errors.apiCodeReasons.environmentImage.harborRobotCreateFailed",
  harbor_robot_credentials_missing:
    "common.errors.apiCodeReasons.environmentImage.harborRobotCredentialsMissing",
  harbor_robot_delete_failed:
    "common.errors.apiCodeReasons.environmentImage.harborRobotDeleteFailed",
  harbor_robot_query_failed: "common.errors.apiCodeReasons.environmentImage.harborRobotQueryFailed",
  harbor_robot_response_invalid:
    "common.errors.apiCodeReasons.environmentImage.harborRobotResponseInvalid",
  import_task_not_found: "common.errors.apiCodeReasons.environmentImage.importTaskNotFound",
  import_task_status_invalid:
    "common.errors.apiCodeReasons.environmentImage.importTaskStatusInvalid",
  name_conflict: "common.errors.apiCodeReasons.environmentImage.nameConflict",
  node_local_ref_invalid: "common.errors.apiCodeReasons.environmentImage.nodeLocalRefInvalid",
  owner_forbidden: "common.errors.apiCodeReasons.environmentImage.ownerForbidden",
  owner_missing: "common.errors.apiCodeReasons.environmentImage.ownerMissing",
  prewarm_active_required: "common.errors.apiCodeReasons.environmentImage.prewarmActiveRequired",
  prewarm_asset_source_required:
    "common.errors.apiCodeReasons.environmentImage.prewarmAssetSourceRequired",
  prewarm_source_unpullable:
    "common.errors.apiCodeReasons.environmentImage.prewarmSourceUnpullable",
  reference_type_invalid: "common.errors.apiCodeReasons.environmentImage.referenceTypeInvalid",
  registry_host_mismatch: "common.errors.apiCodeReasons.environmentImage.registryHostMismatch",
  registry_host_required: "common.errors.apiCodeReasons.environmentImage.registryHostRequired",
  registry_image_tag_required:
    "common.errors.apiCodeReasons.environmentImage.registryImageTagRequired",
  registry_owner_project_name_invalid:
    "common.errors.apiCodeReasons.environmentImage.registryOwnerProjectNameInvalid",
  registry_owner_required: "common.errors.apiCodeReasons.environmentImage.registryOwnerRequired",
  registry_owner_user_required:
    "common.errors.apiCodeReasons.environmentImage.registryOwnerUserRequired",
  registry_project_prefix_invalid:
    "common.errors.apiCodeReasons.environmentImage.registryProjectPrefixInvalid",
  registry_ref_required: "common.errors.apiCodeReasons.environmentImage.registryRefRequired",
  registry_repository_path_required:
    "common.errors.apiCodeReasons.environmentImage.registryRepositoryPathRequired",
  registry_repository_scope_invalid:
    "common.errors.apiCodeReasons.environmentImage.registryRepositoryScopeInvalid",
  registry_repository_segment_invalid:
    "common.errors.apiCodeReasons.environmentImage.registryRepositorySegmentInvalid",
  registry_required_host_missing:
    "common.errors.apiCodeReasons.environmentImage.registryRequiredHostMissing",
  registry_robot_duration_invalid:
    "common.errors.apiCodeReasons.environmentImage.registryRobotDurationInvalid",
  registry_robot_name_invalid:
    "common.errors.apiCodeReasons.environmentImage.registryRobotNameInvalid",
  reimport_name_mismatch: "common.errors.apiCodeReasons.environmentImage.reimportNameMismatch",
  runtime_commit_asset_forbidden:
    "common.errors.apiCodeReasons.environmentImage.runtimeCommitAssetForbidden",
  runtime_commit_login_credentials_forbidden:
    "common.errors.apiCodeReasons.environmentImage.runtimeCommitLoginCredentialsForbidden",
  share_access_forbidden: "common.errors.apiCodeReasons.environmentImage.shareAccessForbidden",
  share_mode_invalid: "common.errors.apiCodeReasons.environmentImage.shareModeInvalid",
  share_target_invalid: "common.errors.apiCodeReasons.environmentImage.shareTargetInvalid",
  source_base_os_required: "common.errors.apiCodeReasons.environmentImage.sourceBaseOsRequired",
  source_ref_required: "common.errors.apiCodeReasons.environmentImage.sourceRefRequired",
  source_type_asset_required:
    "common.errors.apiCodeReasons.environmentImage.sourceTypeAssetRequired",
  tar_import_asset_archive_invalid:
    "common.errors.apiCodeReasons.environmentImage.tarImportAssetArchiveInvalid",
  tar_import_asset_required: "common.errors.apiCodeReasons.environmentImage.tarImportAssetRequired",
  tar_import_parsed_image_missing:
    "common.errors.apiCodeReasons.environmentImage.tarImportParsedImageMissing",
  tar_import_runtime_source_ref_required:
    "common.errors.apiCodeReasons.environmentImage.tarImportRuntimeSourceRefRequired",
  virtualization_type_invalid:
    "common.errors.apiCodeReasons.environmentImage.virtualizationTypeInvalid",
};
